module.exports = __webpack_public_path__ + "static/media/double-standard-img3.7309d890.jpg";